import { combineReducers } from "redux";
import assortimentReducer from "./assortiment/reducer";
import basketReducer from "./basket/reducer";
import currentInformationReducer from "./currentInformation/reducer";
import deliveryReducer from "./delivery/reducer";
import identifyReducer from "./identify/reducer";
import loginReducer from "./login/reducer";
import orderHistoryReducer from "./orderHistory/reducer";

export default combineReducers({
  assortiment: assortimentReducer,
  basket: basketReducer,
  login: loginReducer,
  deliveryDates: deliveryReducer,
  currentInformation: currentInformationReducer,
  orderHistory: orderHistoryReducer,
  identify: identifyReducer,
});
